import styled from 'styled-components';
import { IconButton, BUTTON_VARIANTS, BUTTON_SIZES } from 'ui/button';
import { Note } from 'ui/icons';
import { colors } from 'ui/theme';

const StyledNote = styled(Note)`
  && {
    path {
      stroke: ${colors.mustard100};
    }
  }
`;

type NoteButtonProps = {
  /** onClick function */
  onClick: () => void;
};

export const NoteButton = (props: NoteButtonProps) => {
  return (
    <IconButton variant={BUTTON_VARIANTS.SECONDARY} size={BUTTON_SIZES.LARGE} {...props}>
      <StyledNote />
    </IconButton>
  );
};
